module.exports = __webpack_public_path__ + "img/spa.b1cd1dc5.png";